var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _storage = _interopRequireDefault(require("./storage"));
var _lurker = _interopRequireDefault(require("./lurker"));
var MaxQueueStorage = function MaxQueueStorage(key, max) {
  var load = function () {
    var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var value;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _storage["default"].get(key);
          case 2:
            value = _context.sent;
            if (!value) {
              _context.next = 11;
              break;
            }
            _context.prev = 4;
            return _context.abrupt("return", JSON.parse(value));
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](4);
            _lurker["default"].loadStorageError(value, _context.t0);
          case 11:
            return _context.abrupt("return", {
              list: [],
              map: {}
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 8]]);
    }));
    return function load() {
      return _ref.apply(this, arguments);
    };
  }();
  var put = function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(value) {
      var loaded, toRemove;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return load();
          case 2:
            loaded = _context2.sent;
            if (loaded.list.length >= max) {
              toRemove = loaded.list.shift();
              delete loaded.map[toRemove];
            }
            loaded.list.push(value);
            loaded.map[value] = 1;
            _context2.next = 8;
            return _storage["default"].set(key, JSON.stringify(loaded));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function put(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isIn = function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(value) {
      var loaded;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return load();
          case 2:
            loaded = _context3.sent;
            return _context3.abrupt("return", !!loaded.map[value]);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function isIn(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    put: put,
    isIn: isIn,
    params: {
      key: key,
      max: max
    }
  };
};
var _default = MaxQueueStorage;
exports["default"] = _default;